import React, { useState } from "react";
import { Box, Typography } from "@mui/material";

export default function CircleItem({ image, label, size = 120, onClick, selectedItem }) {
    return (
        <Box
            sx={{
                width: size,
                height: size,
                borderRadius: "50%",
                backgroundColor: "#f5f5f5",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: 3,
                overflow: "hidden",
                position: "relative",
                textAlign: "center",
                padding: 1,
                cursor: "pointer",
                transition: "0.3s",
                border: selectedItem ? "3px solid #1976d2" : "3px solid transparent"
            }}
            onClick={onClick}
        >
            {/* Imagen circular */}
            <Box
                component="img"
                src={image}
                alt={label}
                sx={{
                    width: "60%",
                    height: "60%",
                    objectFit: "contain",
                    mb: 1
                }}
            />
            {/* Label */}
            <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "0.85rem" }}>
                {label}
            </Typography>
        </Box>
    );
}